<form [formGroup]="form">
  <div id="form-container">
    <rds-form-field labelPosition="top">
      <rds-control-label>Select existing or add new profile</rds-control-label>
      <div id="autocomplete-container">
        <rds-autocomplete #autocomplete
                          [options]="options"
                          placeholder="Type anything to search..."
                          [highlightQuery]="true"
                          minSearchChars="1"
                          formControlName="selection"
                          debounce="0"
                          [displayProperty]="displayProperty"
                          [uniqProperty]="uniqProperty"
                          [optionTemplate]="type() == 'profile'? profileOptionTemplate : studyOptionTemplate"
                          data-testid="profile-input"
                          [newItem]="addNew"
                          [newItemTemplate]="type() == 'profile' ? personNewItemTemplate : studyNewItemTemplate"
        />
        <button rds-control-suffix rds-icon-button type="button" (click)="abort()"
                size="s" class="ms-2" data-testid="profile-remove">
          <rds-icon namespace="outlined" icon="close"/>
        </button>
      </div>
    </rds-form-field>
  </div>
  <ng-template
    #profileOptionTemplate
    let-autocomplete
    let-option="option"
    let-keyboardFocusedItem="keyboardFocusedItem"
  >
    <button
      [rdsAutocompleteOption]="autocomplete"
      [keyboardFocusedItem]="keyboardFocusedItem"
      class="rds-list-item rds-list-item--l rds-single-select-list-item"
      (click)="autocomplete.toggle(option)"
    >
      <div class="profile-option-item">
        <div>
          <span [innerHTML]="option.lastName + ', '"
                [rdsAutocompleteHighlight]="autocomplete.getSearchQuery()"></span>
          <span [innerHTML]="option.firstName"
                [rdsAutocompleteHighlight]="autocomplete.getSearchQuery()"></span>
        </div>
        <div>
          <span class="ui-label-m" [innerHTML]="option.institution"
                [rdsAutocompleteHighlight]="autocomplete.getSearchQuery()"></span>
        </div>
      </div>
    </button>
  </ng-template>
  <ng-template
    #studyOptionTemplate
    let-autocomplete
    let-option="option"
    let-keyboardFocusedItem="keyboardFocusedItem"
  >
    <button
      [rdsAutocompleteOption]="autocomplete"
      [keyboardFocusedItem]="keyboardFocusedItem"
      class="rds-list-item rds-list-item--l rds-single-select-list-item"
      (click)="autocomplete.toggle(option)"
    >
      <div>
        <span [innerHTML]="option.studyNumber + (option.studyName? ', ' + option.studyName : '')"
              [rdsAutocompleteHighlight]="autocomplete.getSearchQuery()"></span>
      </div>
    </button>
  </ng-template>
</form>
<ng-template #personNewItemTemplate let-autocomplete let-keyboardFocusedItem="keyboardFocusedItem">
  <div class="add-new-container">
    <rds-form-field
      [rdsAutocompleteOption]="autocomplete"
      [keyboardFocusedItem]="keyboardFocusedItem"
      class="rds-list-item rds-list-item--l rds-single-select-list-item rds-autocomplete-option-new-item"
    >
      <rds-control-label>VeevaLink Profile</rds-control-label>
      <span rds-control-prefix>https://</span>
      <rds-control-prefix-separator></rds-control-prefix-separator>
      <input rdsInput [formControl]="form.controls.veevaURL"/>
      @if (form.controls.veevaURL.errors) {
        <rds-control-error>
          A valid VeevaLink profile URL starts with <b class="token">https://veeva.link/p/</b> and ends with <b class="token">-&#123;profileID&#125;</b>
        </rds-control-error>
      }
    </rds-form-field>
    <div class="w-100 d-flex justify-content-between align-items-center px-5">
      <rds-empty-state size="xs">
        <rds-icon rds-empty-state-icon namespace="outlined" icon="circle_info"
                  #popover="rdsPopover" (click)="popover.toggle()"
                  class="c-primary-pressed"
                  [rdsPopoverHasBackdrop]="true"
                  [rdsPopover]="popoverTextContent"
                  [rdsPopoverShowCloseButton]="true"/>
      </rds-empty-state>
      <button rds-primary-button (click)="veevaURLSubmit()" [disabled]="veevaURLSubmitIsLoading">
          Add
      </button>
    </div>
  </div>
</ng-template>
<ng-template #studyNewItemTemplate let-autocomplete>
  <button class="rds-autocomplete-option-no-data rds-list-item rds-list-item--l" disabled>
    No data for current query.
  </button>
</ng-template>

<ng-template #popoverTextContent>
  <rds-popover-text-content id="textExample">
    <h4 rds-popover-header>Adding a new external profile</h4>
    <div rds-popover-paragraph>
      <ol class="ordered-list ui-body-m">
        <li class="ordered-item">
          <p>Open a new tab and navigate to the <a rds-link href="https://veeva.link/" target="_blank">VeevaLink</a> homepage</p>
        </li>
        <li class="ordered-item">
          Search for the profile of the external {{profileType()}} you want to add.
        </li>
        <li class="ordered-item">
          Once you have located the correct profile, copy the URL from your browser's address bar.
        </li>
        <li class="ordered-item">
          Paste the copied URL into the VeevaLink Profile input field.
        </li>
        <li class="ordered-item">
          Click the "Add" button to include the external {{profileType()}}'s profile in Planwise.
        </li>
      </ol>
      <br/>
      <p class="ui-label-s pt-2">
          Note: The profile will be added to the list of available profiles for selection.
      </p>
    </div>
  </rds-popover-text-content>
</ng-template>
